import {
	AI_QUESTION1_ID,
	AI_QUESTION1_KEY,
	AI_QUESTION2_ID,
	AI_QUESTION2_KEY, EXPLANATION_TEXT_ID, EXPLANATION_TEXT_KEY,
	NEXT_BUTTON_ID,
	NEXT_BUTTON_KEY,
	PROCESSING_LABEL_ID,
	PROCESSING_LABEL_KEY,
	STATE_ID,
	STATE_KEY,
} from '../constants';

const EXPLANATION_TEXT_HTML = '<div class=\"ai-enhanced-form explanation-text\"><b>These last two optional questions below will help our firm gain a clearer understanding of your case.</b><\/div>';
const AI_FIELDS = [
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 5,
		'idAttribute': 'id',
		'type': 'listselect',
		'label': 'AI Enhancement Status',
		'key': STATE_KEY,
		'label_pos': 'above',
		'required': false,
		'options': [
			{
				errors: [],
				max_options: 0,
				label: 'Disabled',
				value: 'disabled',
				calc: '',
				selected: 0,
				order: 0,
				settingModel: {
					settings: false,
					hide_merge_tags: false,
					error: false,
					name: 'options',
					type: 'option-repeater',
					label: 'Options <a href="#" class=\nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
					width: 'full',
					group: '',
					value: [
						{
							label: 'One',
							value: 'one',
							calc: '',
							selected: 0,
							order: 0,
						}, {
							label: 'Two',
							value: 'two',
							calc: '',
							selected: 0,
							order: 1,
						}, {
							label: 'Three',
							value: 'three',
							calc: '',
							selected: 0,
							order: 2,
						}],
					columns: {
						label: {
							header: 'label',
							default: '',
						},
						value: {
							header: 'value',
							default: '',
						},
						calc: {
							header: 'Calc Value',
							default: '',
						},
						selected: {
							header: '<span class="dashicons dashicons-yes"><\/span>',
							default: 0,
						},
					},
				},
				manual_value: true,
			},
			{
				errors: [],
				max_options: 0,
				label: 'Enabled (Initial State)',
				value: 'enabled',
				calc: 1,
				selected: 1,
				order: 1,
				settingModel: {
					settings: false,
					hide_merge_tags: false,
					error: false,
					name: 'options',
					type: 'option-repeater',
					label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
					width: 'full',
					group: '',
					value: [
						{
							label: 'One',
							value: 'one',
							calc: '',
							selected: 0,
							order: 0,
						}, {
							label: 'Two',
							value: 'two',
							calc: '',
							selected: 0,
							order: 1,
						}, {
							label: 'Three',
							value: 'three',
							calc: '',
							selected: 0,
							order: 2,
						}],
					columns: {
						label: {
							header: 'label',
							default: '',
						},
						value: {
							header: 'value',
							default: '',
						},
						calc: {
							header: 'Calc Value',
							default: '',
						},
						selected: {
							header: '<span class="dashicons dashicons-yes"><\/span>',
							default: 0,
						},
					},
				},
				manual_value: true,
			},
			{
				errors: [],
				max_options: 0,
				label: 'Processing',
				value: 'processing',
				calc: 2,
				selected: 0,
				order: 2,
				settingModel: {
					settings: false,
					hide_merge_tags: false,
					error: false,
					name: 'options',
					type: 'option-repeater',
				},
				manual_value: true,
			},
			{
				errors: [],
				max_options: 0,
				label: 'Enabled (Questions)',
				value: 'ai_enhanced',
				calc: 3,
				selected: 0,
				order: 3,
				settingModel: {
					settings: false,
					hide_merge_tags: false,
					error: false,
					name: 'options',
					type: 'option-repeater',
					label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
					width: 'full',
					group: '',
					value: [
						{
							label: 'One',
							value: 'one',
							calc: '',
							selected: 0,
							order: 0,
						}, {
							label: 'Two',
							value: 'two',
							calc: '',
							selected: 0,
							order: 1,
						}, {
							label: 'Three',
							value: 'three',
							calc: '',
							selected: 0,
							order: 2,
						}],
					columns: {
						label: {
							header: 'label',
							default: '',
						},
						value: {
							header: 'value',
							default: '',
						},
						calc: {
							header: 'Calc Value',
							default: '',
						},
						selected: {
							header: '<span class="dashicons dashicons-yes"><\/span>',
							default: 0,
						},
					},
				},
				manual_value: true,
			},
			{
				errors: [],
				max_options: 0,
				order: 4,
				new: false,
				options: [],
				label: 'Enabled (No Questions)',
				value: 'no_questions',
				calc: 4,
				selected: 0,
				settingModel: {
					settings: false,
					hide_merge_tags: false,
					error: false,
					name: 'options',
					type: 'option-repeater',
					label: 'Options <a href="#" class="nf-add-new">Add New<\/a> <a href="#" class="extra nf-open-import-tooltip"><i class="fa fa-sign-in" aria-hidden="true"><\/i> Import<\/a>',
					width: 'full',
					group: '',
					value: [
						{
							label: 'One',
							value: 'one',
							calc: '',
							selected: 0,
							order: 0,
						}, {
							label: 'Two',
							value: 'two',
							calc: '',
							selected: 0,
							order: 1,
						}, {
							label: 'Three',
							value: 'three',
							calc: '',
							selected: 0,
							order: 2,
						}],
					columns: {
						label: {
							header: 'label',
							default: '',
						},
						value: {
							header: 'value',
							default: '',
						},
						calc: {
							header: 'Calc Value',
							default: '',
						},
						selected: {
							header: '<span class="dashicons dashicons-yes"><\/span>',
							default: 0,
						},
					},
				},
				manual_value: true,
			},
		],
		'container_class': '',
		'element_class': '',
		'admin_label': '',
		'help_text': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'wrap_styles_show_advanced_css': 0,
		'label_styles_border': '',
		'label_styles_width': '',
		'label_styles_font-size': '',
		'label_styles_margin': '',
		'label_styles_padding': '',
		'label_styles_float': '',
		'label_styles_show_advanced_css': 0,
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'element_styles_show_advanced_css': 0,
		'cellcid': 'c4062',
		'drawerDisabled': false,
		'id': STATE_ID,
		'beforeField': '',
		'afterField': '',
		'value': '1',
		'parentType': 'list',
		'element_templates': ['listselect', 'input'],
		'old_classname': 'list-select',
		'wrap_template': 'wrap',
	},
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 10,
		'idAttribute': 'id',
		'type': 'html',
		'label': 'Processing •••',
		'default': '',
		'container_class': 'ai-enhanced-form processing-field-container',
		'element_class': '',
		'wrap_styles_show_advanced_css': 0,
		'label_styles_show_advanced_css': 0,
		'element_styles_show_advanced_css': 0,
		'cellcid': 'c3758',
		'key': PROCESSING_LABEL_KEY,
		'drawerDisabled': false,
		'field_label': '',
		'field_key': PROCESSING_LABEL_KEY,
		'admin_label': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'label_styles_border': '',
		'label_styles_width': '',
		'label_styles_font-size': '',
		'label_styles_margin': '',
		'label_styles_padding': '',
		'label_styles_float': '',
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'id': PROCESSING_LABEL_ID,
		'beforeField': '',
		'afterField': '',
		'value': '',
		'label_pos': 'above',
		'parentType': 'html',
		'element_templates': ['html', 'input'],
		'old_classname': '',
		'wrap_template': 'wrap',
	},
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 6,
		'idAttribute': 'id',
		'type': 'textbox',
		'label': 'AI Question 1',
		'key': AI_QUESTION1_KEY,
		'label_pos': 'above',
		'required': false,
		'default': '',
		'placeholder': '',
		'container_class': '',
		'element_class': '',
		'input_limit': '',
		'input_limit_type': 'characters',
		'input_limit_msg': 'Character(s) left',
		'manual_key': false,
		'admin_label': '',
		'help_text': '',
		'mask': '',
		'custom_mask': '',
		'custom_name_attribute': '',
		'personally_identifiable': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'wrap_styles_show_advanced_css': 0,
		'label_styles_border': '',
		'label_styles_width': '',
		'label_styles_font-size': '',
		'label_styles_margin': '',
		'label_styles_padding': '',
		'label_styles_float': '',
		'label_styles_show_advanced_css': 0,
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'element_styles_show_advanced_css': 0,
		'cellcid': 'c4399',
		'value': '',
		'id': AI_QUESTION1_ID,
		'beforeField': '',
		'afterField': '',
		'parentType': 'textbox',
		'element_templates': ['textbox', 'input'],
		'old_classname': '',
		'wrap_template': 'wrap',
	},
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 7,
		'idAttribute': 'id',
		'type': 'textbox',
		'label': 'AI Question 2',
		'key': AI_QUESTION2_KEY,
		'label_pos': 'above',
		'required': false,
		'default': '',
		'placeholder': '',
		'container_class': '',
		'element_class': '',
		'input_limit': '',
		'input_limit_type': 'characters',
		'input_limit_msg': 'Character(s) left',
		'manual_key': false,
		'admin_label': '',
		'help_text': '',
		'mask': '',
		'custom_mask': '',
		'custom_name_attribute': '',
		'personally_identifiable': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'wrap_styles_show_advanced_css': 0,
		'label_styles_border': '',
		'label_styles_width': '',
		'label_styles_font-size': '',
		'label_styles_margin': '',
		'label_styles_padding': '',
		'label_styles_float': '',
		'label_styles_show_advanced_css': 0,
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'element_styles_show_advanced_css': 0,
		'cellcid': 'c7815',
		'value': '',
		'drawerDisabled': false,
		'id': AI_QUESTION2_ID,
		'beforeField': '',
		'afterField': '',
		'parentType': 'textbox',
		'element_templates': ['textbox', 'input'],
		'old_classname': '',
		'wrap_template': 'wrap',
	},
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 12,
		'idAttribute': 'id',
		'type': 'submit',
		'label': 'Next',
		'processing_label': 'Processing',
		'container_class': '',
		'element_class': '',
		'key': NEXT_BUTTON_KEY,
		'wrap_styles_show_advanced_css': 0,
		'element_styles_show_advanced_css': 0,
		'submit_element_hover_styles_show_advanced_css': 0,
		'cellcid': 'c9683',
		'drawerDisabled': '',
		'field_label': 'Next',
		'field_key': NEXT_BUTTON_KEY,
		'admin_label': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'submit_element_hover_styles_border': '',
		'submit_element_hover_styles_width': '',
		'submit_element_hover_styles_font-size': '',
		'submit_element_hover_styles_margin': '',
		'submit_element_hover_styles_padding': '',
		'submit_element_hover_styles_float': '',
		'id': NEXT_BUTTON_ID,
		'beforeField': '',
		'afterField': '',
		'value': '',
		'label_pos': 'above',
		'parentType': 'textbox',
		'element_templates': ['submit', 'button', 'input'],
		'old_classname': '',
		'wrap_template': 'wrap-no-label',
	},
	{
		'objectType': 'Field',
		'objectDomain': 'fields',
		'editActive': false,
		'order': 10,
		'idAttribute': 'id',
		'type': 'html',
		'label': '',
		'default': EXPLANATION_TEXT_HTML,
		'container_class': '',
		'element_class': '',
		'wrap_styles_show_advanced_css': 0,
		'label_styles_show_advanced_css': 0,
		'element_styles_show_advanced_css': 0,
		'cellcid': 'c3758',
		'key': EXPLANATION_TEXT_KEY,
		'drawerDisabled': false,
		'field_label': '',
		'field_key': EXPLANATION_TEXT_KEY,
		'admin_label': '',
		'wrap_styles_border': '',
		'wrap_styles_width': '',
		'wrap_styles_margin': '',
		'wrap_styles_padding': '',
		'wrap_styles_float': '',
		'label_styles_border': '',
		'label_styles_width': '',
		'label_styles_font-size': '',
		'label_styles_margin': '',
		'label_styles_padding': '',
		'label_styles_float': '',
		'element_styles_border': '',
		'element_styles_width': '',
		'element_styles_font-size': '',
		'element_styles_margin': '',
		'element_styles_padding': '',
		'element_styles_float': '',
		'id': EXPLANATION_TEXT_ID,
		'beforeField': '',
		'afterField': '',
		'value': EXPLANATION_TEXT_HTML,
		'label_pos': 'above',
		'parentType': 'html',
		'element_templates': ['html', 'input'],
		'old_classname': '',
		'wrap_template': 'wrap',
	},
];

export default AI_FIELDS;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/resources/fields.js